"use client";

import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Button } from "@/components/buttons/Button";
import { Modal } from "@/components/Modal";
import { deleteConversionMultiAction } from "@/data/conversion/actions/deleteConversionMultiAction";
import { logError } from "@/utils/logError";

export function DeleteConversionMultiModal({
  open,
  closeModal,
  conversionMultiId,
  conversionCount,
}: {
  open: boolean;
  closeModal: () => void;
  conversionMultiId: string;
  conversionCount: number;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const deleteHandler = async () => {
    setIsLoading(true);

    try {
      await deleteConversionMultiAction({ conversionMultiId });
      closeModal();
    } catch (error) {
      logError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Delete all conversions"
      widthMode="normal"
    >
      <div className="sm:flex sm:items-center">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <ExclamationTriangleIcon
            className="h-6 w-6 text-red-600"
            aria-hidden="true"
          />
        </div>
        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
          <p className="text-sm text-gray-500">
            Are you sure you want to delete all {conversionCount} conversion
            {conversionCount === 1 ? "" : "s"}? This action cannot be undone.
          </p>
        </div>
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <Button variant="ghost" onClick={closeModal} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="error"
          onClick={deleteHandler}
          disabled={isLoading}
          loading={isLoading}
        >
          Delete all
        </Button>
      </div>
    </Modal>
  );
}
